import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import { SketchPicker, ChromePicker } from 'react-color'

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(1)
    },
    container: {
        display: "flex",
        alignItems: "center"
    },
    color: {
        width: '36px',
        height: '14px',
        borderRadius: '2px'
    },
    colorName: {
        marginLeft: theme.spacing(1),
        fontSize: "1.1em"
    },
    swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
        display: 'inline-block',
        cursor: 'pointer',
    },
    popover: {
        position: 'absolute',
        zIndex: '2',
    },
    cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
    },
    disabled: {
        opacity: ".5",
        backgroundColor: "#d1d1d1"
    }
}));

function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

function hexToRgbA(hex) {
    if (typeof hex != 'string') hex = '';
    let c;
    if (hex.length == 4 || hex.length == 7) hex += "FF";
    if (/^#([A-Fa-f0-9]{2}){1,4}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length == 5) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2], c[3], c[4]];
        }
        c = '0x' + c.join('');
        return {
            hex,
            rgb: {
                r: ((c >> 32) & 255).toString(),
                g: ((c >> 16) & 255).toString(),
                b: ((c >> 8) & 255).toString(),
                a: round(((c & 255) / 255), 1).toString()
            }
        };
    } else {
        return {
            hex: "#FFF",
            rgb: {
                r: "255",
                g: "255",
                b: "255",
                a: "1"
            }
        };
    }
}

export const ColorPicker = ({
    value,
    disabled,
    onChange,
    ...props
}) => {

    const classes = useStyles();

    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    const [color, setColor] = useState(hexToRgbA(value));

    const showPickerHandler = () => {
        if (disabled) return;
        setDisplayColorPicker(!displayColorPicker);
    };

    const closePickerHandler = () => {
        setDisplayColorPicker(false);
    };

    const colorChangeHandler = (c) => {
        let alpha = round((c.rgb.a * 255), 1).toString(16).split(".")[0];
        if (alpha.length < 2) alpha = "0" + alpha;
        const hex = `${c.hex}${alpha}`;
        const color = hexToRgbA(hex);
        setColor(color);
    };

    const colorChangeCompleteHandler = (c) => {
        let alpha = round((c.rgb.a * 255), 1).toString(16).split(".")[0];
        if (alpha.length < 2) alpha = "0" + alpha;
        const hex = `${c.hex}${alpha}`;
        const color = hexToRgbA(hex);
        setColor(color);
        if (onChange) onChange(color)
    };

    return (
        <div className={clsx(classes.root, props.className)}>
            <div className={classes.container}>
                <div
                    className={classes.swatch}
                    onClick={showPickerHandler}>
                    <div
                        className={clsx(classes.color, disabled ? classes.disabled : null)}
                        style={{ backgroundColor: value }}
                    />
                </div>
                <div className={classes.colorName}>
                    {value}
                </div>
            </div>
            {displayColorPicker ?
                <div className={classes.popover}>
                    <div
                        className={classes.cover}
                        onClick={closePickerHandler} />
                    <ChromePicker
                        color={color}
                        onChange={colorChangeHandler}
                        onChangeComplete={colorChangeCompleteHandler}
                    />
                </div>
                :
                null
            }
        </div>
    )
}